<template>
    <div ref="mapRef" class="map"></div>
</template>

<script>
import L from 'leaflet';

export default {
    props: {
        device: {
            type: Object,
            default: null
        },
        checkpoints: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            map: null,
            deviceMarker: null,
            checkpointsMarkers: [],
        }
    },
    mounted() {
        this.map = L.map(this.$refs.mapRef).setView([50.0795, 14.4302], 16);

        L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            maxZoom: 20
        }).addTo(this.map);

        if (this.device) {
            this.renderDevice(this.device);
        }

        if (this.checkpoints) {
            this.renderCheckpoints(this.checkpoints);
        }

    },
    methods: {
        invalidate() {
            if (this.map) {
                this.map.invalidateSize()
            }
        },
        renderDevice(device) {
            const latLng = [device.latitude, device.longitude];

            if (!this.deviceMarker) {
                this.deviceMarker = L.circleMarker(latLng, {
                    radius: 8,
                    color: "blue",
                    fillColor: "blue",
                    fillOpacity: 0.8
                }).addTo(this.map);

                if (device.name) {
                    this.deviceMarker.bindPopup(`<strong>${device.name}</strong>`);
                }
            } else {
                this.deviceMarker.setLatLng(latLng)
            }

            this.fitAllBounds();
        },
        renderCheckpoints(checkpoints) {
            this.checkpointsMarkers.forEach(marker => this.map.removeLayer(marker));
            this.checkpointsMarkers = [];

            checkpoints.forEach(cp => {
                const lat = cp.latitude;
                const lng = cp.longitude;

                if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

                const marker = L.circleMarker([lat, lng], {
                    radius: 6,
                    color: "#28a745",
                    fillColor: "#28a745",
                    fillOpacity: 0.8
                }).addTo(this.map)

                if (cp.tag_name) {
                    marker.bindPopup(`<strong>${cp.tag_name}</strong>`);
                }

                this.checkpointsMarkers.push(marker);

            });

            this.fitAllBounds();
        },
        fitAllBounds() {
            const latLngs = [];

            if (this.deviceMarker) {
                latLngs.push(this.deviceMarker.getLatLng());
            }

            this.checkpointsMarkers.forEach(cp => latLngs.push(cp.getLatLng()));

             if (latLngs.length >= 1) {
                const bounds = L.latLngBounds(latLngs);
                this.map.fitBounds(bounds, { padding: [40, 40], maxZoom: 19 });
            }
        }
    },
    watch: {
        device: {
            handler(newDevice) {
                if (newDevice?.latitude && newDevice?.longitude) {
                    this.renderDevice(newDevice);
                }
            }
        },
        checkpoints: {
            handler(newCheckpoints) {
                if (Array.isArray(newCheckpoints)) {
                    this.renderCheckpoints(newCheckpoints);
                }
            },
            deep: true,
            immediate: true
        }
    }
}
</script>

<style>
.map {
    width: 100%;
    height: 500px;
}
</style>